import { type ReactNode, type FC } from 'react';
import { AiTutorAndContactUs } from './AiTutorAndContactUs';
import { ContactUs } from './ContactUs';

export const SupportModalBody: FC<{ AiTutorComponent?: ReactNode | null }> = ({ AiTutorComponent }) =>
    AiTutorComponent ? <AiTutorAndContactUs AiTutorComponent={AiTutorComponent} /> : <ContactUs />;
